import React, { useState } from "react";
import {
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Checkbox,
  MenuItem,
  Menu,
  Typography,
  Pagination,
} from "@mui/material";
import {
  PrimaryTypography,
  StyledSecondaryServiceTypography,
  StyledOutlinedInput,
  SecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  StyledSecondaryTypography,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
import moment from "moment";
import { StatusChip } from "../../CommonComponents/StatusChip";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { useNavigate } from "react-router-dom";

const SalesOverview = () => {
  const navigate = useNavigate();
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const sortOpen = Boolean(sortAnchorEl);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterOpen = Boolean(filterAnchorEl);
  const [currentPage, setCurrentPage] = useState(1);
  const TableHeaders = [
    "Company",
    "Project",
    "Type",
    "Status",
    "Start Date",
    "Action",
  ];

  const TableData = [
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "onboarding",
      startDate: new Date(),
      action: "View Details",
    },
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "trial ending",
      startDate: new Date(),
      action: "View Details",
    },
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "onboarding",
      startDate: new Date(),
      action: "View Details",
    },
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "active",
      startDate: new Date(),
      action: "View Details",
    },
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "renewal",
      startDate: new Date(),
      action: "View Details",
    },
    {
      company: "Singapore Land Group",
      project: "The Clement Canopy",
      type: "Residential",
      status: "inactive",
      startDate: new Date(),
      action: "View Details",
    },
  ];

  const filterData = ["Onboarding", "Active", "Renewal", "Inactive"];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <PrimaryTypography>Sales Overview</PrimaryTypography>
          <StyledSecondaryServiceTypography>
            Manage all of your post sales funnel information
          </StyledSecondaryServiceTypography>
        </Box>
        <Button
          style={{
            borderRadius: "8px",
            padding: "10px 16px 10px 16px",
            backgroundColor: "#0E5E84",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "14px",
          }}
          onClick={() => navigate("/create-account")}
        >
          Add Account{" "}
        </Button>
      </Box>
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          p: 3,
          mt: 4,
          borderRadius: " 8px 8px 0px 0px",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            height: "40px",
            minWidth: "580px",
          }}
        >
          <StyledOutlinedInput
            sx={{ flexGrow: 1 }}
            placeholder="Search"
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #E5E7EB",
              borderRadius: "6px",
              px: 2,
              ml: 2,
              "&:hover": { cursor: "pointer" },
            }}
            onClick={(e) => {
              setSortAnchorEl(e.currentTarget);
            }}
          >
            <SortIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>Sort</SecondaryTypography>
          </Box>
          <Box
            onClick={(e) => setFilterAnchorEl(e.currentTarget)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #E5E7EB",
              borderRadius: "6px",
              px: 2,
              ml: 2,
              "&:hover": { cursor: "pointer" },
            }}
          >
            <FilterIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>Filters</SecondaryTypography>
          </Box>
        </Box>
      </Box>
      {TableData.length > 0 ? (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <StyledTableRow sx={{ height: "44px" }}>
                  <StyledTableCell>
                    {" "}
                    <Checkbox
                      sx={{ height: "40px", minWidth: "43px" }}
                      size="small"
                      icon={<CheckboxIcon />}
                    />
                  </StyledTableCell>
                  {TableHeaders.map((value, index) => (
                    <StyledTableCell key={index}>{value}</StyledTableCell>
                  ))}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {TableData.map((value, index) => (
                  <StyledTableRow
                    onClick={() => navigate("/review-account/1")}
                    key={index}
                    sx={{ height: "70px" }}
                  >
                    <StyledTableCell>
                      {" "}
                      <Checkbox
                        sx={{ height: "40px", minWidth: "43px" }}
                        size="small"
                        icon={<CheckboxIcon />}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{value?.company}</StyledTableCell>
                    <StyledTableCell>{value?.project}</StyledTableCell>
                    <StyledTableCell>{value?.type}</StyledTableCell>
                    <StyledTableCell>
                      {StatusChip(value?.status)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {moment(value?.startDate).format("DD MMM YYYY")}
                    </StyledTableCell>
                    <StyledTableCell>{value?.action}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              borderTopStyle: "none !important",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
              >
                Show :
              </Typography>
              {/* <OutlinedInput
                    inputProps={{ min: 5, max: 30, step: 5 }}
                    value={rowsPerPage}
                    onChange={(e) => setRowsPerPage(e.target.value)}
                    type="number"
                    sx={{
                      height: "40px",
                      width: "100px",
                      ml: 2,
                      borderRadius: "8px",
                    }}
                  /> */}
              <Box
                // onClick={(e) => setshowAnchorEl(e.currentTarget)}
                sx={{
                  width: "95px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #E5E7EB",
                  borderRadius: "6px",
                  ml: 2,
                  "&:hover": { cursor: "pointer" },
                }}
              >
                {/* <Typography
                    sx={{ fontSize: "15px" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {rowsPerPage} rows{" "}
                    <NumberInputIcon style={{ paddingLeft: "5px" }} />
                  </Typography> */}
              </Box>
            </Box>
            <Pagination
              page={currentPage}
              size="medium"
              // count={paginationData?.last_page}
              // onChange={(e, value) => setCurrentPage(value)}
              // shape="rounded"
              // renderItem={(item) => (
              //   <PaginationItem
              //     slots={{ previous: PreviousIcon, next: NextIcon }}
              //     {...item}
              //   />
              // )}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "50vh",
            justifyContent: "center",
            borderRadius: "0px 0px 8px 8px",
            border: "1px solid #F9FAFB",
            backgroundColor: "#F9FAFB",
          }}
        >
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Account Here
            </Typography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              There are no account to display at the moment.
            </StyledSecondaryTypography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              You may add account by clicking the top right Add button.
            </StyledSecondaryTypography>
          </>
        </Box>
      )}

      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setSortAnchorEl(null);
          }}
        >
          <Typography>Most Recent</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortAnchorEl(null);
          }}
        >
          <Typography>Oldest</Typography>
        </MenuItem>
      </Menu>
      <Menu
        sx={{ width: "312px", height: "459px" }}
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
      >
        {filterData?.map((itm, index) => (
          <MenuItem key={index}>
            <Checkbox
              sx={{ width: "42px", height: "42px" }}
              icon={<CheckboxIcon />}
            />
            <Typography sx={{ mr: 3 }}>{itm}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SalesOverview;
